import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { Container, Button } from "react-bootstrap";
import { AmplitudePageName, track } from "utils/amplitude";
import styles from "./WriteForOrchid.module.scss";
import getClasses from "utils/getClasses";

interface WriteForOrchidProps {
  amplitudePageName: AmplitudePageName;
}

const AMPLITUDE_COMPONENT_NAME = "write-for-us-blog-cta";

const WriteForOrchid = ({ amplitudePageName }: WriteForOrchidProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <Container
      className={getClasses(
        styles["write-for-orchid"],
        isPhonePortrait && styles["write-for-orchid--phone"],
      )}
    >
      <div className={styles["title"]}>
        Are you interested in writing for Orchid?
      </div>
      <Button
        className={styles["cta-button"]}
        variant={"primary"}
        size={isPhonePortrait ? undefined : "lg"}
        onClick={() => {
          track(
            amplitudePageName,
            [AMPLITUDE_COMPONENT_NAME, "learn-more-button"],
            "click",
          );
          window.open("/write-for-us");
        }}
      >
        Learn More
      </Button>
    </Container>
  );
};

export default WriteForOrchid;
